import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { Router } from '@angular/router';
import { DevelopersRoutes } from '../../models/developers-routes';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent {
  @Input() public icon: CustomIcons;
  @Input() public title: string;
  @Input() public text: string;
  @Input() public buttonName: string;
  @Input() public mobileText?: string;
  @Input() public route?: DevelopersRoutes;
  @Input() public click?: () => void;

  constructor(private router: Router) {}

  public redirect(): void {
    if (this.click) {
      this.click();
    }
    if (this.route) {
      this.router.navigate([`developers/${this.route}`]);
    }
  }
}
